var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"zzjgBox"},[_c('img',{attrs:{"src":_vm.zzjgImg}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }